module.exports = __webpack_public_path__ + "static/media/Arya Tewary.6448a58c.jpeg";